
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { i18n } from "@/resources/locales";
import Loader from "@/resources/mixins/loader/loader";
@Component({})
export default class ActivateRegistration extends mixins(NotificationEvent, Loader) {
  mounted() {
    const { token } = this.$route.query;
    this.startLoader(this.$store);
    this.$store.dispatch("HawkingsStore/activateRegistrationAction", { 
      token,
      callback: (response) => {
        this.stopLoader(this.$store);
        if (response.data.status === "KO") {
          this.onError(
            i18n.t("notifications.titles.error"),
            i18n.t("register.activationAlreadyDone"),
            "none"
          );
        } else {
          this.$router.push("/main").catch(() => {
            // do nothing
          });
        }
      },
      callbackError: (error) => {
        this.stopLoader(this.$store);
        this.onError(
          i18n.t("notifications.titles.error"),
          i18n.t("notifications.genericError.genericError", {
            code: error.response.status,
          }),
          "none"
        );
      },
    });
  }
}
